/**
 * AB#1797 (CR-2026-05-29) — Small tier-badge overlay for locked filter controls.
 *
 * Clicking routes to /settings/billing/upgrade with attribution params so
 * App Insights can track which locked feature drove the upgrade click.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation as useTranslationUntyped } from 'react-i18next';
import s from './UpgradeChip.module.css';

const useTranslation = useTranslationUntyped as any;

export interface UpgradeChipProps {
    tier: 'Growth' | 'Pro' | 'Enterprise';
    /** Feature key for App Insights attribution. */
    featureKey?: string;
    position?: 'overlay' | 'inline';
}

const UpgradeChip: React.FC<UpgradeChipProps> = ({
    tier,
    featureKey = 'unknown',
    position = 'overlay',
}) => {
    const navigate = useNavigate();
    const { t } = useTranslation('appointments');

    const label = t('list.tierLocked', { tier });

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        navigate(`/settings/billing/upgrade?from=appointments-list&feature=${featureKey}`);
    };

    return (
        <button
            type="button"
            className={`${s.chip} ${s[`chip--${position}`]}`}
            onClick={handleClick}
            title={label}
            aria-label={label}
        >
            {tier}
        </button>
    );
};

export default UpgradeChip;
